/**
 * @group Components
 * 
 * @summary
 * <blockquote>Submit button component for authentication forms with loading state.</blockquote>
 * 
 * @example
 * ```tsx
 * <AuthSubmitButton
 *   mode="signin"
 *   isPending={isPending}
 * />
 * ```
 */

import { Button } from '../../buttons';
import { UI_MESSAGES, UI_ACTIONS } from '@shared/constants';
import type { AuthSubmitButtonProps } from './AuthSubmitButtonProps';

/**
 * Submit button component for authentication forms
 */
export function AuthSubmitButton({ mode, isPending }: AuthSubmitButtonProps) {
  return (
    <Button 
      type="submit" 
      className="w-full" 
      disabled={isPending}
    >
      {isPending ? (
        <div className="flex items-center gap-2">
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
          <span>
            {mode === UI_ACTIONS.AUTH.SIGNIN 
              ? UI_MESSAGES.AUTH.SIGNING_IN 
              : UI_MESSAGES.AUTH.CREATING_ACCOUNT}
          </span>
        </div>
      ) : (
        mode === UI_ACTIONS.AUTH.SIGNIN 
          ? UI_MESSAGES.AUTH.SIGN_IN 
          : UI_MESSAGES.AUTH.SIGN_UP
      )}
    </Button>
  );
}
